import { render, staticRenderFns } from "./ConfirmarDadosVoucher.vue?vue&type=template&id=1f013616&scoped=true&"
import script from "./ConfirmarDadosVoucher.vue?vue&type=script&lang=js&"
export * from "./ConfirmarDadosVoucher.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmarDadosVoucher.vue?vue&type=style&index=0&id=1f013616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f013616",
  null
  
)

export default component.exports